import RenditionGuide from '@/docs-partials/optional-settings/rendition-guide.mdx';
import * as React from 'react';
export default {
  RenditionGuide,
  React
};